const Twig = require('twig');
(function ($, Drupal, window) {
  window.r_build_pager = function (element, route_name, total, total_pages, current_page, target, templateId) {
    var variables = {
      element,
      template: templateId,
      target,
      pager: {
        '#element': element,
        '#parameters': '',
        '#quantity': 3,
        '#route_name': route_name,
        '#route_parameters': [],
        '#tags': []
      },
      services: {
        'pager.manager': {
          [element]: {
            total: total_pages,
            current_page: current_page
          }
        }
      }
    };
    r_template_preprocess_pager(variables);
    var pager = document.getElementById('r-script-pager');
    var pagerContent = pager.innerHTML;
    var template = Twig.twig({
      data: pagerContent
    });

    pagerContent = template.render(variables);
    return pagerContent;
  };
  window.r_template_preprocess_pager = (variables) => {
    let element = variables['pager']['#element'];
    let parameters = variables['pager']['#parameters'];
    let quantity = parseInt(variables['pager']['#quantity'] ? variables['pager']['#quantity'] : 0);
    let route_name = variables['pager']['#route_name'];
    let route_parameters = variables['pager']['#route_parameters'] || [];

    // Invoking pager manager service
    let pager_manager = variables['services']['pager.manager'];
    let pager = pager_manager[element];

    if (!pager) {
      return;
    }

    let pager_max = pager['total'];

    if (pager_max <= 1) {
      return;
    }

    let tags = variables['pager']['#tags'];
    let pager_middle = Math.ceil(quantity / 2);
    let current_page = parseInt(pager['current_page'] ? pager['current_page'] : 0);
    let pager_current = current_page + 1;
    let pager_first = pager_current - pager_middle + 1;
    let pager_last = pager_current + quantity - pager_middle;

    let i = pager_first;

    if (pager_last > pager_max) {
      i += pager_max - pager_last;
      pager_last = pager_max;
    }

    if (i <= 0) {
      pager_last += 1 - i;
      i = 1;
    }

    let items = {};

    if (current_page > 0) {
      // "First" link
      items['first'] = {
        attributes: {}
      };
      let options = {
        query: 'pager=0'
      };
      // @TODO: Should check if route_name contains '?' then use '&'
      items['first']['href'] = route_name + '&' + options.query;
      if (tags && tags[0]) {
        items['first']['text'] = tags[0];
      }

      // "Previous" link
      items['previous'] = {
        attributes: {}
      };
      options = {
        query: 'pager=' + (current_page - 1)
      };
      items['previous']['href'] = route_name + '&' + options.query;
      if (tags && tags[1]) {
        items['previous']['text'] = tags[1];
      }
    }

    if (i != pager_max) {
      if (i > 1) {
        // Add ellipsis for previous pages
        variables['ellipses'] = { previous: true };
      }

      // Generate actual pager piece
      for (; i <= pager_last && i <= pager_max; i++) {
        let options = {
          query: 'pager=' + (element, i - 1)
        };
        items['pages'] = items['pages'] || {};
        items['pages'][i] = {
          href: route_name + '&' + options.query,
          attributes: {}
        };

        if (i === pager_current) {
          variables['current'] = i;
        }
      }

      if (i < pager_max + 1) {
        // Add ellipsis for next pages
        variables['ellipses'] = variables['ellipses'] || {};
        variables['ellipses']['next'] = true;
      }
    }

    if (current_page < pager_max - 1) {
      // "Next" link
      items['next'] = {
        attributes: {}
      };
      let options = {
        query: 'pager=' + (current_page + 1)
      };
      items['next']['href'] = route_name + '&' + options.query;
      if (tags && tags[3]) {
        items['next']['text'] = tags[3];
      }

      // "Last" link
      items['last'] = {
        attributes: {}
      };
      options = {
        query: 'pager=' + (pager_max - 1)
      };
      items['last']['href'] = route_name + '&' + options.query;
      if (tags && tags[4]) {
        items['last']['text'] = tags[4];
      }
    }

    variables['items'] = items;
    variables['heading_id'] = 'pagination-heading';
    return variables;
  };

  (function ($, Drupal) {
    Drupal.behaviors.r_ajax_hubspot_pager = {
      attach: function (context, settings) {
        $('body')
          .find('.r-ajax-pager')
          .once('inited')
          .each(function () {
            const $pager = $(this);
            $(this)
              .find('[data-rel-href]')
              .once('inited')
              .click((e) => {
                e.preventDefault();
                const $link = $(event.currentTarget);
                const href = $link.attr('data-rel-href');
                const target = $pager.attr('data-target');
                const element = $pager.attr('data-element');
                const template = $pager.attr('data-template');
                const route_name = $pager.attr('data-route_name');
                r_apply_json(element, template, target, href, route_name, () => {
                  $([document.documentElement, document.body]).animate(
                    {
                      scrollTop: $(target).offset().top
                    },
                    600
                  );
                });
              });
          });
      }
    };
  })(jQuery, Drupal);
})(jQuery, Drupal, window);
